import AxiosManageShop from './axios_manage_api'

const ModuleManageShop = {
  state: {
    Category: [],
    Supplier: [],
    Brand: [],
    ProductBySellerID: [],
    EditProduct: '',
    GetUserAddress: '',
    CreateAddressUser: '',
    CheckAddressUserLocal: '',
    UpdateSellerShopDetail: '',
    CreateInventory: '',
    CreateProductShop: '',
    GetInventory: '',
    EditProductShop: '',
    CreateSupplier: '',
    CreateBrand: '',
    listTierAndDoc: [],
    newCategories: [],
    GetStatusShop: [],
    GetListIship: [],
    GetCourierType: [],
    CancelOrderIship: [],
    UpdateOrderIship: [],
    GetStatusIship: [],
    GetListCourierIship: [],
    PrintListCourierIship: [],
    CreateRequestCourierIship: [],
    PrintLabelPDFIship: [],
    PrintLabelShippingPDFIship: [],
    GetCourierList: [],
    GetCourierListII: [],
    UpdateCourierList: [],
    UpdateStatusShipping: [],
    stateListCreateShipping: [],
    stateCreateOrderIshipSelect: [],
    stateUpdateRemarkShop: [],
    stateUpdateRemarkAdmin: [],
    stateRequestSellerShop: [],
    stateRequestSellerShopDetail: [],
    CreateRequestCourierIshipV2: [],
    stateGetListCourierIshipV2: [],
    stateGetListIshipAdmin: [],
    stateEditShippingAddress: [],
    stateGetB2BDeliveryList: [],
    GetListIshipIII: [],
    GetCourierTypeII: [],
    GetShipmentsImages: [],
    GetListIshipB2B: [],
    stateGetlistCreateShippingB2B: [],
    stateGetCourierListB2B: [],
    stateRemarkShopB2B: [],
    stateUpdateOrderB2B: [],
    stateCreateOrderIshipB2B: [],
    stateListRequestCourierB2B: [],
    stateRequestCourierB2B: [],
    stateListCreateShippingII: [],
    stateCancelOrderShipping: [],
    stateCreateFeature: [],
    stateGetDataFeature: [],
    stateUpdateRemarkShopV2: [],
    stateInternalCeateOrderShipping: [],
    stateExternalCeateOrderShipping: [],
    statePickupRequests: [],
    stateUpdateShippingOrders: [],
    stateOrderListNewCouriers: [],
    stateGetdetailOrderList: [],
    stateGetStatusOrderList: [],
    stateGetShopGropCouriers: [],
    stateGeneratePackingList: [],
    stateTrackingOrderInternal: []
  },
  mutations: {
    SetCategory (state, data) {
      state.Category = data
    },
    SetSupplier (state, data) {
      state.Supplier = data
    },
    SetBrand (state, data) {
      state.Brand = data
    },
    SetProductBySellerID (state, data) {
      state.ProductBySellerID = data
    },
    SetEditProduct (state, data) {
      state.EditProduct = data
    },
    SetGetUserAddress (state, data) {
      state.GetUserAddress = data
    },
    SetCreateAddressUser (state, data) {
      state.CreateAddressUser = data
    },
    SetCheckAddressUserLocal (state, data) {
      state.CheckAddressUserLocal = data
    },
    SetUpdateSellerShopDetail (state, data) {
      state.UpdateSellerShopDetail = data
    },
    SetCreateInventory (state, data) {
      state.CreateInventory = data
    },
    SetCreateProductShop (state, data) {
      state.CreateProductShop = data
    },
    SetGetInventory (state, data) {
      state.GetInventory = data
    },
    SetEditProductShop (state, data) {
      state.EditProductShop = data
    },
    SetCreateSupplier (state, data) {
      state.CreateSupplier = data
    },
    SetCreateBrand (state, data) {
      state.CreateBrand = data
    },
    SetlistTierAndDoc (state, data) {
      state.listTierAndDoc = data
    },
    SetListDirectDeal (state, data) {
      state.ListDirectDealData = data
    },
    MutationCreateCategories (state, data) {
      state.newCategories = data
    },
    MutationsGetStatusShop (state, data) {
      state.GetStatusShop = data
    },
    MutationsGetListIship (state, data) {
      state.GetListIship = data
    },
    MutationsGetCourierType (state, data) {
      state.GetCourierType = data
    },
    MutationsCancelOrderIship (state, data) {
      state.CancelOrderIship = data
    },
    MutationsUpdateOrderIship (state, data) {
      state.UpdateOrderIship = data
    },
    MutationsGetStatusIship (state, data) {
      state.GetStatusIship = data
    },
    MutationsGetListCourierIship (state, data) {
      state.GetListCourierIship = data
    },
    MutationsPrintListCourierIship (state, data) {
      state.PrintListCourierIship = data
    },
    MutationsCreateRequestCourierIship (state, data) {
      state.CreateRequestCourierIship = data
    },
    MutationsPrintLabelPDFIship (state, data) {
      state.PrintLabelPDFIship = data
    },
    MutationsPrintLabelShippingPDFIship (state, data) {
      state.PrintLabelShippingPDFIship = data
    },
    MutationsGetCourierList (state, data) {
      state.GetCourierList = data
    },
    MutationsGetCourierListII (state, data) {
      state.GetCourierListII = data
    },
    MutationsUpdateCourierList (state, data) {
      state.UpdateCourierList = data
    },
    MutationsUpdateStatusShipping (state, data) {
      state.UpdateStatusShipping = data
    },
    MutationsListCreateShipping (state, data) {
      state.stateListCreateShipping = data
    },
    MutationsCreateOrderIshipSelect (state, data) {
      state.stateCreateOrderIshipSelect = data
    },
    MutationsUpdateRemarkShop (state, data) {
      state.stateUpdateRemarkShop = data
    },
    MutationsUpdateRemarkAdmin (state, data) {
      state.stateUpdateRemarkAdmin = data
    },
    MutationsRequestSellerShop (state, data) {
      state.stateRequestSellerShop = data
    },
    MutationsRequestSellerShopDetail (state, data) {
      state.stateRequestSellerShopDetail = data
    },
    MutationsCreateRequestCourierIshipV2 (state, data) {
      state.CreateRequestCourierIshipV2 = data
    },
    MutationsGetListCourierIshipV2 (state, data) {
      state.stateGetListCourierIshipV2 = data
    },
    MutationsGetListIshipAdmin (state, data) {
      state.stateGetListIshipAdmin = data
    },
    MutationsEditShippingAddress (state, data) {
      state.stateEditShippingAddress = data
    },
    MutationsGetB2BDeliveryList (state, data) {
      state.stateGetB2BDeliveryList = data
    },
    MutationsGetListIshipIII (state, data) {
      state.GetListIshipIII = data
    },
    MutationsGetCourierTypeII (state, data) {
      state.GetCourierTypeII = data
    },
    MutationsGetShipmentsImages (state, data) {
      state.GetShipmentsImages = data
    },
    MutationsGetListIshipB2B (state, data) {
      state.GetListIshipB2B = data
    },
    MutationsGetlistCreateShippingB2B (state, data) {
      state.stateGetlistCreateShippingB2B = data
    },
    MutationsGetCourierListB2B (state, data) {
      state.stateGetCourierListB2B = data
    },
    MutationsRemarkShopB2B (state, data) {
      state.stateRemarkShopB2B = data
    },
    MutationsUpdateOrderB2B (state, data) {
      state.stateUpdateOrderB2B = data
    },
    MutationsCreateOrderIshipB2B (state, data) {
      state.stateCreateOrderIshipB2B = data
    },
    MutationsListRequestCourierB2B (state, data) {
      state.stateListRequestCourierB2B = data
    },
    MutationsRequestCourierB2B (state, data) {
      state.stateRequestCourierB2B = data
    },
    MutationsListCreateShippingII (state, data) {
      state.stateListCreateShippingII = data
    },
    MutationsCancelOrderShipping (state, data) {
      state.stateCancelOrderShipping = data
    },
    MutationsCreateFeature (state, data) {
      state.stateCreateFeature = data
    },
    MutationsGetDataFeature (state, data) {
      state.stateGetDataFeature = data
    },
    MutationsUpdateRemarkShopV2 (state, data) {
      state.stateUpdateRemarkShopV2 = data
    },
    MutationsInternalCeateOrderShipping (state, data) {
      state.stateInternalCeateOrderShipping = data
    },
    MutationsExternalCeateOrderShipping (state, data) {
      state.stateExternalCeateOrderShipping = data
    },
    MutationsPickupRequests (state, data) {
      state.statePickupRequests = data
    },
    MutationsUpdateShippingOrders (state, data) {
      state.stateUpdateShippingOrders = data
    },
    MutationsOrderListNewCouriers (state, data) {
      state.stateOrderListNewCouriers = data
    },
    MutationsGetdetailOrderList (state, data) {
      state.stateGetdetailOrderList = data
    },
    MutationsGetStatusOrderList (state, data) {
      state.stateGetStatusOrderList = data
    },
    MutationsGetShopGropCouriers (state, data) {
      state.stateGetShopGropCouriers = data
    },
    MutationsGeneratePackingList (state, data) {
      state.stateGeneratePackingList = data
    },
    MutationsTrackingOrderInternal (state, data) {
      state.stateTrackingOrderInternal = data
    }
  },
  actions: {
    async GetCagegory (context) {
      var res = await AxiosManageShop.GetCagegory()
      await context.commit('SetCategory', res)
    },
    async GetSupplier (context) {
      var res = await AxiosManageShop.GetSupplier()
      await context.commit('SetSupplier', res)
    },
    async GetBrand (context) {
      var res = await AxiosManageShop.GetBrand()
      await context.commit('SetBrand', res)
    },
    async GetProductBySellerID (context, data) {
      var res = await AxiosManageShop.GetProductBySellerID(data)
      await context.commit('SetProductBySellerID', res)
    },
    async CreateBrand (context, data) {
      var res = await AxiosManageShop.CreateBrand(data)
      await context.commit('SetCreateBrand', res)
    },
    async CreateSupplier (context, data) {
      var res = await AxiosManageShop.CreateSupplier(data)
      await context.commit('SetCreateSupplier', res)
    },
    async GetDefaultCagegory (context) {
      var res = await AxiosManageShop.GetDefaultCagegory()
      await context.commit('SetCategory', res)
    },
    async GetUserAddress (context, data) {
      var res = await AxiosManageShop.GetUserAddress(data)
      await context.commit('SetGetUserAddress', res)
    },
    async CreateAddressUser (context, data) {
      var res = await AxiosManageShop.CreateAddressUser(data)
      await context.commit('SetCreateAddressUser', res)
    },
    async CheckAddressUserLocal (context, data) {
      var res = await AxiosManageShop.CheckAddressUserLocal(data)
      await context.commit('SetCheckAddressUserLocal', res)
    },
    async UpdateAddressCart (context, data) {
      await AxiosManageShop.UpdateAddressCart(data)
      // await context.commit('SetCreateAddressUser', res)
    },
    async UpdateSellerShopDetail (context, data) {
      var res = await AxiosManageShop.UpdateSellerShopDetail(data.dataShop)
      await context.commit('SetUpdateSellerShopDetail', res)
    },
    async CreateInventory (context, data) {
      var res = await AxiosManageShop.CreateInventory(data)
      await context.commit('SetCreateInventory', res)
    },
    async CreateProductShop (context, data) {
      var res = await AxiosManageShop.CreateProductShop(data)
      await context.commit('SetCreateProductShop', res)
    },
    async EditProductShop (context, data) {
      var res = await AxiosManageShop.EditProductShop(data)
      await context.commit('SetEditProductShop', res)
    },
    async GetInventory (context, data) {
      var res = await AxiosManageShop.GetInventory(data)
      await context.commit('SetGetInventory', res)
    },
    async GetListTierAndDoc (context, data) {
      var res = await AxiosManageShop.ListTierAndDoc(data)
      await context.commit('SetlistTierAndDoc', res)
    },
    async ActionCreateCategories (context, data) {
      var res = await AxiosManageShop.CreateCagegory(data)
      await context.commit('MutationCreateCategories', res)
    },
    async ActionsGetStatusShop (context, data) {
      var res = await AxiosManageShop.GetStatusShop(data)
      await context.commit('MutationsGetStatusShop', res)
    },
    async ActionsGetListIship (context, data) {
      var res = await AxiosManageShop.GetListIship(data)
      await context.commit('MutationsGetListIship', res)
    },
    async ActionsGetCourierType (context, data) {
      var res = await AxiosManageShop.GetCourierType(data)
      await context.commit('MutationsGetCourierType', res)
    },
    async ActionsCancelOrderIship (context, data) {
      var res = await AxiosManageShop.CancelOrderIship(data)
      await context.commit('MutationsCancelOrderIship', res)
    },
    async ActionsUpdateOrderIship (context, data) {
      var res = await AxiosManageShop.UpdateOrderIship(data)
      await context.commit('MutationsUpdateOrderIship', res)
    },
    async ActionsGetStatusIship (context, data) {
      var res = await AxiosManageShop.GetStatusIship(data)
      await context.commit('MutationsGetStatusIship', res)
    },
    async ActionsGetListCourierIship (context, data) {
      var res = await AxiosManageShop.GetListCourierIship(data)
      await context.commit('MutationsGetListCourierIship', res)
    },
    async ActionsPrintListCourierIship (context, data) {
      var res = await AxiosManageShop.PrintListCourierIship(data)
      await context.commit('MutationsPrintListCourierIship', res)
    },
    async ActionsCreateRequestCourierIship (context, data) {
      var res = await AxiosManageShop.CreateRequestCourierIship(data)
      await context.commit('MutationsCreateRequestCourierIship', res)
    },
    async ActionsPrintLabelPDFIship (context, data) {
      var res = await AxiosManageShop.PrintLabelPDFIship(data)
      await context.commit('MutationsPrintLabelPDFIship', res)
    },
    async ActionsPrintLabelShippingPDFIship (context, data) {
      var res = await AxiosManageShop.PrintLabelShippingPDFIship(data)
      await context.commit('MutationsPrintLabelShippingPDFIship', res)
    },
    async ActionsGetCourierList (context, data) {
      var res = await AxiosManageShop.GetCourierList(data)
      await context.commit('MutationsGetCourierList', res)
    },
    async ActionsGetCourierListII (context, data) {
      var res = await AxiosManageShop.GetCourierListII(data)
      await context.commit('MutationsGetCourierListII', res)
    },
    async ActionsUpdateCourierList (context, data) {
      var res = await AxiosManageShop.UpdateCourierList(data)
      await context.commit('MutationsUpdateCourierList', res)
    },
    async ActionsUpdateStatusShipping (context, data) {
      var res = await AxiosManageShop.UpdateStatusShipping(data)
      await context.commit('MutationsUpdateStatusShipping', res)
    },
    async ActionsListCreateShipping (context, data) {
      var res = await AxiosManageShop.ListCreateShipping(data)
      await context.commit('MutationsListCreateShipping', res)
    },
    async ActionsCreateOrderIshipSelect (context, data) {
      var res = await AxiosManageShop.CreateOrderIshipSelect(data)
      await context.commit('MutationsCreateOrderIshipSelect', res)
    },
    async ActionsUpdateRemarkShop (context, data) {
      var res = await AxiosManageShop.UpdateRemarkShop(data)
      await context.commit('MutationsUpdateRemarkShop', res)
    },
    async ActionsUpdateRemarkAdmin (context, data) {
      var res = await AxiosManageShop.UpdateRemarkAdmin(data)
      await context.commit('MutationsUpdateRemarkAdmin', res)
    },
    async ActionsRequestSellerShop (context, data) {
      var res = await AxiosManageShop.RequestSellerShop(data)
      await context.commit('MutationsRequestSellerShop', res)
    },
    async ActionsRequestSellerShopDetail (context, data) {
      var res = await AxiosManageShop.RequestSellerShopDetail(data)
      await context.commit('MutationsRequestSellerShopDetail', res)
    },
    async ActionsCreateRequestCourierIshipV2 (context, data) {
      var res = await AxiosManageShop.CourierIshipV2(data)
      await context.commit('MutationsCreateRequestCourierIshipV2', res)
    },
    async ActionsGetListCourierIshipV2 (context, data) {
      var res = await AxiosManageShop.GetListCourierIshipV2(data)
      await context.commit('MutationsGetListCourierIshipV2', res)
    },
    async ActionsGetListIshipAdmin (context, data) {
      var res = await AxiosManageShop.GetListIshipAdmin(data)
      await context.commit('MutationsGetListIshipAdmin', res)
    },
    async ActionsEditShippingAddress (context, data) {
      var res = await AxiosManageShop.EditShippingAddress(data)
      await context.commit('MutationsEditShippingAddress', res)
    },
    async ActionsGetB2BDeliveryList (context, data) {
      var res = await AxiosManageShop.GetB2BDeliveryList(data)
      await context.commit('MutationsGetB2BDeliveryList', res)
    },
    async ActionsGetListIshipIII (context, data) {
      var res = await AxiosManageShop.GetListIshipIII(data)
      await context.commit('MutationsGetListIshipIII', res)
    },
    async ActionsGetCourierTypeII (context, data) {
      var res = await AxiosManageShop.GetCourierTypeII(data)
      await context.commit('MutationsGetCourierTypeII', res)
    },
    async ActionsGetShipmentsImages (context, data) {
      var res = await AxiosManageShop.GetShipmentsImages(data)
      await context.commit('MutationsGetShipmentsImages', res)
    },
    async ActionsGetListIshipB2B (context, data) {
      var res = await AxiosManageShop.GetListIshipB2B(data)
      await context.commit('MutationsGetListIshipB2B', res)
    },
    async ActionsGetlistCreateShippingB2B (context, data) {
      var res = await AxiosManageShop.GetlistCreateShippingB2B(data)
      await context.commit('MutationsGetlistCreateShippingB2B', res)
    },
    async ActionsGetCourierListB2B (context, data) {
      var res = await AxiosManageShop.GetCourierListB2B(data)
      await context.commit('MutationsGetCourierListB2B', res)
    },
    async ActionsRemarkShopB2B (context, data) {
      var res = await AxiosManageShop.remarkShopB2B(data)
      await context.commit('MutationsRemarkShopB2B', res)
    },
    async ActionsUpdateOrderB2B (context, data) {
      var res = await AxiosManageShop.updateOrderB2B(data)
      await context.commit('MutationsUpdateOrderB2B', res)
    },
    async ActionsCreateOrderIshipB2B (context, data) {
      var res = await AxiosManageShop.CreateOrderIshipB2B(data)
      await context.commit('MutationsCreateOrderIshipB2B', res)
    },
    async ActionsListRequestCourierB2B (context, data) {
      var res = await AxiosManageShop.ListRequestCourierB2B(data)
      await context.commit('MutationsListRequestCourierB2B', res)
    },
    async ActionsRequestCourierB2B (context, data) {
      var res = await AxiosManageShop.requestCourierB2B(data)
      await context.commit('MutationsRequestCourierB2B', res)
    },
    async ActionsListCreateShippingII (context, data) {
      var res = await AxiosManageShop.ListCreateShippingII(data)
      await context.commit('MutationsListCreateShippingII', res)
    },
    async ActionsCancelOrderShipping (context, data) {
      var res = await AxiosManageShop.CancelOrderShipping(data)
      await context.commit('MutationsCancelOrderShipping', res)
    },
    async ActionsCreateFeature (context, data) {
      var res = await AxiosManageShop.CreateFeature(data)
      await context.commit('MutationsCreateFeature', res)
    },
    async ActionsGetDataFeature (context, data) {
      var res = await AxiosManageShop.GetDataFeature(data)
      await context.commit('MutationsGetDataFeature', res)
    },
    async ActionsListDirectDeal (context, data) {
      var res = await AxiosManageShop.ListDirectDeal(data)
      await context.commit('SetListDirectDeal', res)
    },
    async ActionsUpdateRemarkShopV2 (context, data) {
      var res = await AxiosManageShop.UpdateRemarkShopV2(data)
      await context.commit('MutationsUpdateRemarkShopV2', res)
    },
    async ActionsInternalCeateOrderShipping (context, data) {
      var res = await AxiosManageShop.InternalCeateOrderShipping(data)
      await context.commit('MutationsInternalCeateOrderShipping', res)
    },
    async ActionsExternalCeateOrderShipping (context, data) {
      var res = await AxiosManageShop.ExternalCeateOrderShipping(data)
      await context.commit('MutationsExternalCeateOrderShipping', res)
    },
    async ActionsPickupRequests (context, data) {
      var res = await AxiosManageShop.PickupRequests(data)
      await context.commit('MutationsPickupRequests', res)
    },
    async ActionsUpdateShippingOrders (context, data) {
      var res = await AxiosManageShop.UpdateShippingOrders(data)
      await context.commit('MutationsUpdateShippingOrders', res)
    },
    async ActionsOrderListNewCouriers (context, data) {
      var res = await AxiosManageShop.OrderListNewCouriers(data)
      await context.commit('MutationsOrderListNewCouriers', res)
    },
    async ActionsGetdetailOrderList (context, data) {
      var res = await AxiosManageShop.GetdetailOrderList(data)
      await context.commit('MutationsGetdetailOrderList', res)
    },
    async ActionsGetStatusOrderList (context, data) {
      var res = await AxiosManageShop.GetStatusOrderList(data)
      await context.commit('MutationsGetStatusOrderList', res)
    },
    async ActionsGetShopGropCouriers (context, data) {
      var res = await AxiosManageShop.GetShopGropCouriers(data)
      await context.commit('MutationsGetShopGropCouriers', res)
    },
    async ActionsGeneratePackingList (context, data) {
      var res = await AxiosManageShop.GeneratePackingList(data)
      await context.commit('MutationsGeneratePackingList', res)
    },
    async ActionsTrackingOrderInternal (context, data) {
      var res = await AxiosManageShop.TrackingOrderInternal(data)
      await context.commit('MutationsTrackingOrderInternal', res)
    }
  }
}
export default ModuleManageShop
